import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { LoginWrapperComponent } from './login-wrapper/login-wrapper.component';
import { LogsComponent } from './logs/logs.component';
import { LookupsComponent } from './lookups/lookups.component';
import { AdminAuthGuardService, AuthGuardService, LookupsAuthGuardService, ReportsAuthGuardService, UnsavedChangesGuardService } from './services/auth-guard.service';
import { AttributionComponent } from './attribution/attribution.component';
import { ReportsComponent } from './reports/reports.component';
import { CloseComponent } from './close/close.component';
import { EulaComponent } from './eula/eula.component';
import { PrivacyComponent } from './privacy/privacy.component';

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', component: LoginWrapperComponent },
  { path: 'login/out', component: LoginWrapperComponent, data: { out: -1 } },
  { path: 'EULA', component: EulaComponent },
  { path: 'PRIVACY', component: PrivacyComponent },
  { path: 'home', component: HomeComponent,
      canActivate: [AuthGuardService],
      canDeactivate: [UnsavedChangesGuardService] },
  { path: 'reports', component: ReportsComponent,
    canActivate: [ReportsAuthGuardService],
    canDeactivate: [UnsavedChangesGuardService] },
  { path: 'lookup-tables', component: LookupsComponent,
      canActivate: [LookupsAuthGuardService],
      canDeactivate: [UnsavedChangesGuardService] },
  { path: 'attribution', component: AttributionComponent},
  { path: 'logs', component: LogsComponent, canActivate: [AdminAuthGuardService] },
  { path: 'close', component: CloseComponent },
  { path: '**', component: LoginWrapperComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
